const usersMainView = {
  bindings: {
    allAccounts: '<'
  },
  templateUrl: '/modules/users/main-view/main-view.html',
  controller: 'UsersMainViewController',
};

angular
  .module('users.module')
  .component('usersMainView', usersMainView)
  .config($stateProvider => {
    $stateProvider
      .state('users', {
        url: '/users',
        component: 'usersMainView',
        resolve: {
          auth: function (userService, $state, eventService) {
            return userService
              .resolve(['ACCESS_USERS'])
              .then(() => { })
              .catch(() => {
                eventService.trigger('userservice:unauthorized');
                $state.go('frontpage');
              });
          },
          allAccounts: accountService => accountService.getAll(),
        }
      });
  });
